import PublicationCreatePet from './PublicationCreatePet';
import SelectLocation from './SelectLocation';
import PetCategories from './PetCategories';
import PetProfile from './PetProfile';
import PublicationPreview from './PublicationPreview';
import PublicationPreviewAvatar from './PublicationPreviewAvatar';
import PublicationSliderGallery from './PublicationSliderGallery';
import PetFilters from './PetFilters';
import PublicationDonations from './PublicationDonations';
import PublicationEdit from './PublicationEdit';
import PublicationSuccess from './PublicationSuccess';


const createPetWithDonations = [
    {
        title: 'Выберите категорию объявления',
        progress: { title: 'Выбор категории', step: 2 },
        component: PublicationCreatePet, valid: true, required: true,
    },
    {
        title: 'Населенный пункт',
        progress: { title: 'Выбор региона', step: 3 },
        component: SelectLocation, valid: true, required: true,
    },
    {
        title: 'Укажите категорию вашего питомца',
        progress: { title: 'Выбор категории', step: 4 },
        component: PetCategories, valid: true, required: true,
    },
    {
        title: 'Укажите данные вашего питомца',
        progress: { title: 'Ввод данных', step: 5 },
        component: PetProfile, valid: true, required: true,
    },
    {
        title: 'Введите текст объявления',
        progress: { title: 'Текст объявления', step: 6 },
        component: PublicationPreview, valid: true, required: true,
    },
    {
        title: 'Загрузите фото для вашего объявления',
        progress: { title: 'Фото профиля', step: 7 },
        component: PublicationPreviewAvatar, valid: true, required: true,
    },
    {
        title: 'Загрузите фото для галереи питомца',
        progress: { title: 'Фото объявления', step: 8 },
        component: PublicationSliderGallery, valid: true, required: true,
    },
    {
        title: 'Дополнительно',
        progress: { title: 'Дополнительно', step: 9 },
        subtitle: 'Данная страница не обязательна для заполнения',
        component: PetFilters, valid: true, required: false,
    },
    {
        title: 'Сбор средств (если необходимо)',
        progress: { title: 'Сбор средств', step: 10 },
        component: PublicationDonations, valid: true, required: true,
    },
    {
        title: 'Проверьте правильность введенных данных',
        progress: { title: 'Проверка введенных данных', step: 11 },
        component: PublicationEdit, valid: true, required: true,
    },
    {
        progress: { title: 'Спасибо', step: 12 },
        component: PublicationSuccess, valid: true, required: true,
    },
];

export default createPetWithDonations;
